/**
 * The official «@bing» system identity — the SENDER of every in-app broadcast / inbox
 * message (distinct from bot DMs). It is NOT a real user row; a fixed display identity the
 * web renders as the message sender, with the official/verified badge. Its handle («bing»)
 * is reserved (see reserved-usernames.ts) so no real user can impersonate it.
 */
export const BING_SYSTEM_IDENTITY = {
  appUsername: "bing",
  /** Shown name (Persian). */
  displayName: "بینگ",
  isOfficial: true as const,
} as const;

/**
 * The default Persian message shown when the platform is in MAINTENANCE and a regular user
 * tries to use it. An admin may override it from the panel (`AppSettings.maintenanceMessage`);
 * this is the fallback when they have not set one.
 *
 * Maintenance is an EMERGENCY KILL-SWITCH, enforced server-side in two places — the api's
 * `authenticate` hook (every mini-app request) and the game-server's join gate (every new
 * room join). Admins bypass both, so they can still get in and fix things.
 */
export const MAINTENANCE_MESSAGE = "در حال به‌روزرسانی هستیم، به‌زودی برمی‌گردیم";
